export default __webpack_public_path__ + "static/media/metamask-case-logo.04405101.png";